<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <v-card>
    <div>
      <div class="d-flex align-center">
        <div class="text-subtitle-1">
          {{ $t('ActivateTakeaway') }}
        </div>
        <v-spacer />
        <v-btn
          icon
          @click="closeCard"
        >
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </div>
    </div>

    <div>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-row
          class="align-baseline"
          no-gutters
        >
          <div class="text-body-1 mt-4">
            {{ $t('inputTakeawayDomain') }}
          </div>
          <div class="text-caption text--secondary">
            {{ $t('takeawayDomainRule') }}
          </div>
          <v-text-field
            v-model="subdomainName"
            :disabled="checkDeviceIdDomainnameStatus"
            :hint="$t('EnterTakeawayUrl')"
            :rules="rule"
            class="mt-1"
            dense
            outlined
            persistent-hint
            prefix="http://"
            required
            suffix=".takeaway.aaden.io"
          />
        </v-row>
      </v-form>

      <div class=" mt-2">
        <v-btn
          :disabled="!valid"
          :loading="isLoading"
          block
          color="amber lighten-4 black--text"
          elevation="0"
          @click="continueProcess"
        >
          {{ $t('Activation') }}
        </v-btn>
      </div>
    </div>
    <v-dialog
      v-model="activeInfoDialog"
      width="600"
      @click:outside="closeInfoCard"
    >
      <v-card

        class="pa-4 "
      >
        <v-card-title class="text-h3">
          {{ $t('TakeawayActivation') }}
        </v-card-title>
        <v-card-text
          class="d-flex align-center justify-center overflow-y-auto"
          style=" min-height: 200px"
        >
          <div v-html="checkMessage" />
        </v-card-text>
        <v-card-actions>
          <v-btn
            block
            color="amber lighten-4 black--text"
            elevation="0"
            @click="closeInfoCard"
          >
            {{ $t('closed') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import {
  checkVersionPass,
  delayPromise,
  fullActiveTakeawayWeb,
  setRecords,
  showRecords,
  syncData
} from '@/model/dataLayer/api/takeaway/TakeawayManager'
import i18n from '@/i18n'
import GlobalSettings from '@/model/global/GlobalSettings'

export default {
  name: 'activeTakeawayWebDialog.vue',
  props: {
    value: { type: Boolean },
    allSubdomainName: {},
    allRecords: {}
  },
  data () {
    return {
      // progress: 2,
      subdomainName: '',
      // activeCard: false,
      activeInfoDialog: false,
      error: false,
      step: 0,
      valid: true,
      rule: [
        v => !!v || this.$t('URLCantEmpty'),
        () => !this.checkDeviceIdDomainname ||
            this.$t('thisHostnameAlreadyUse')
      ],
      isLoading: false,
      infoDialog: false,
      addTakeawayDialog: false,
      dataTerminalId: '',
      checkMessage: '',
      storeList: [],
      activeFinish: false
    }
  },
  computed: {
    checkDeviceIdDomainnameStatus () {
      return this.allRecords.find(it => it.deviceId.toString() === GlobalSettings.DeviceId.toString())
    },
    checkDeviceIdDomainname () {
      if (this.allSubdomainName.includes(this.subdomainName)) {
        return !this.checkDeviceIdDomainnameStatus
      } else {
        return false
      }
    }
  },
  watch: {
    // value (val) {
    //   this.activeCard = val
    // },
  },
  mounted () {
    const res = this.allRecords.find(it => it.deviceId.toString() === GlobalSettings.DeviceId.toString())
    if (res) {
      this.subdomainName = res.subdomainName
    } else {
      this.subdomainName = ''
    }
  },
  methods: {
    i18n () {
      return i18n
    },
    closeCard () {
      this.$emit('input', false)
    },
    async checkVersion () {
      try {
        const result = await checkVersionPass()
        if (!result) {
          await this.setMessage(i18n.t('BackendIsOutdatedUpdateImmediately'), false)
          this.showError()
        }
      } catch (e) {
        await this.setMessage(i18n.t('Ngrok没开，请先打开Ngrok然后再设置外卖网站'), false)
        this.showError()
      }
    },
    async checkDataTerminalId () {
      try {
        [this.dataTerminalId, this.checkMessage] = await fullActiveTakeawayWeb(
          async (m, o) =>
            await this.setMessage(m, o, false)
        )
        this.storeList = await this.loadStore()

        if (this.storeList.find(s => s.dataTerminalId === this.dataTerminalId)) {
          await this.setMessage(i18n.t('外卖网站已经开通过！不用重新弄!'), false)
          this.showError()
        } else {
          this.activeInfoDialog = true
          await this.finishActive()
          this.activeInfoDialog = false
          this.closeCard()
          this.$emit('reloadTakeawayPage')
        }
      } catch (e) {
        this.activeInfoDialog = true
        this.checkMessage = e
      }
    },

    async finishActive () {
      await setRecords(this.subdomainName, this.dataTerminalId)
      await this.setMessage(i18n.t('openSuccess'), true, true)
      await this.setMessage(i18n.t('正在自动刷新信息。。。。'), true, true)
      try {
        await syncData()
      } catch (e) {
        console.log(e, 'error')
      }
      this.activeFinish = true
      console.log('active finish')
    },

    async continueProcess () {
      if (this.$refs.form.validate()) {
        this.isLoading = true

        await this.checkVersion()
        if (!this.error) {
          await this.checkDataTerminalId()
        }

        this.isLoading = false
      }
    },

    closeInfoCard () {
      this.error = false
      this.activeInfoDialog = false
      if (this.activeFinish) {
        this.closeCard()
      }
    },

    showError () {
      this.activeInfoDialog = true
      this.error = true
    },

    async setMessage (message = '', ok = true, append = false) {
      this.checkResult = ok
      if (append) {
        this.checkMessage = this.checkMessage + (append ? '<br>' : '') + (ok ? '👌  ' : '❌  ') + message
      } else {
        this.checkMessage = (ok ? '👌  ' : '❌  ') + message
        await delayPromise(500)
      }
    },
    async loadStore () {
      await this.setMessage(i18n.t('已经加载了FireBase上的新内容'))
      return await showRecords()
    }

  }
}
</script>

<style scoped>

</style>
